/* eslint-disable class-methods-use-this */
import React from 'react';
import { withRouter } from 'react-router-dom';
import { cookies, storage } from 'src/utils';
import { getAliOpenInfo } from 'src/utils/bridge';
import { getEnv, getHospitalHostname } from 'src/utils/env';
import addHistoryListener from 'src/utils/historyListener';
import initSeraphMonitorSDK from 'src/utils/initMonitor';
import { Deserialize } from 'src/utils/serialization';
import { SOURCE_KEY, dmXcxSource, zafshealthGhAppId } from 'src/utils/staticData';
import { loadJS } from 'src/utils/tool';
import validate from 'src/utils/validate';
import { xlfowElementPushEventS } from 'src/xlfowPoints';

type Props = any;
declare global {
  interface Window {
    // XFlow: any;
    _XFLOW_: any;
    __setFontSize__: any;
    eruda: any;
    _zals: any;
    _maEvt: any;
    reactHistory: any;
    wx: any;
  }
}

function noop() {}

class App extends React.Component<Props> {
  state = {
    /** 默认值，不展示子节点。检验是否会出现微信重定向跳转，再决定是否展示子节点。如果触发微信获取code的重定向逻辑，此时不展示子节点，否则Auth组件中的各种第三方code2Session逻辑会被重复执行 */
  };

  componentDidMount() {
    this.setHistory();
    this.setEruda();
    this.initXFLOW();
    this.initSeraph();
    this.setChannel();
    this.setHideTabBar();
    this.setPublicOAuth();
    this.weixinAuth();
    this.loadPlatformJsSDK();
    this.setViewPortHeight();
    this.handleWindowResize();
  }

  componentDidUpdate() {
    this.setChannel();
    this.setHideTabBar();
  }

  setPublicOAuth = () => {
    // 互医公众号授权
    const {
      location: { search },
    } = this.props;
    const { from, oauth, channelResourceCode } = Deserialize(search);
    if (oauth) {
      cookies.set('publicOauth', true);
    }
    const publicOauth = cookies.get('publicOauth');
    if (from === 'public' && !publicOauth && channelResourceCode) {
      window.location.href = `https://${getHospitalHostname()}/hospital/oauth?url=${encodeURIComponent(
        window.location.href,
      )}&channelResourceCode=${channelResourceCode}`;
    }
  };

  setEruda() {
    // getEnv() !== 'prd' && eruda.init();
    if (getEnv() !== 'prd') {
      import('eruda').then((eruda) => {
        eruda.default.init();
      });
    }
  }

  setHistory = () => {
    // 设置全局history变量
    console.log('history', this.props);
    window.reactHistory = this.props.history;
  };

  setViewPortHeight = () => {
    const viewPortHeightListener = () => {
      // 设置当前页面的 viewPort 视窗高度到 css 变量中
      document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
    };
    addHistoryListener({
      replaceListener: viewPortHeightListener,
      pushListener: viewPortHeightListener,
      popListener: viewPortHeightListener,
    });
    viewPortHeightListener();
  };

  handleWindowResize = () => {
    window.onresize = () => {
      document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
    };
  };

  setChannel = () => {
    const {
      location: { search },
    } = this.props;
    /**
     * channelPoint: 通用渠道码，标识业务
     * source: 小程序 webview 跳转 H5 来源标识 (主要是自有小程序)
     * appCode: 第三方应用标识 (如直营小程序)
     */
    const { channelPoint, source, appCode, openId, promoteCode } = Deserialize(search);
    // iframe 里与主方伞首页非同源，换用 sessionStorage 存储
    (validate.isFSIframe() && !sessionStorage.getItem('channelPoint'))
      && sessionStorage.setItem('channelPoint', channelPoint);
    channelPoint && cookies.set('channelPoint', channelPoint);
    promoteCode && cookies.set('promoteCode', promoteCode);
    (source || appCode) && sessionStorage.setItem(SOURCE_KEY, source || appCode);

    // 保存来自不同应用的 openId
    sessionStorage.setItem(`${source || appCode}_openId`, openId);

    // 在直营保险小程序里，从互医透传 openId
    if (appCode === dmXcxSource && openId) {
      storage.set('dmOpenId', openId);
    }
  };

  // 按 channelPoint 来隐藏底部 tabBar
  setHideTabBar = () => {
    const {
      location: { pathname },
    } = this.props;
    // 互医来源需要隐藏 tabBar 的渠道点位
    const HYHideTabBarChannelPoint = {
      dev: 'Jk4QLN7T',
      test: 'Jk4QLN7T',
      pre: 'D2dSNTW5',
      prd: '2Y0hcqGQ',
    }[getEnv()];

    if (pathname === '/') {
      if (cookies.get('channelPoint') === HYHideTabBarChannelPoint) {
        cookies.set('hideTabBar', 1);
      } else {
        cookies.remove('hideTabBar');
      }
    }
  };

  /**
   * 方伞商户微信授权
   * @returns void
   */
  weixinAuth = () => {
    if (validate.isZAFSHealth() && validate.isFromWeixin()) {
      const {
        location: { search },
        user,
      } = this.props;
      const { code } = Deserialize(search);
      if (code || user.openid) {
        return;
      }
      const appid = zafshealthGhAppId;
      let redirectUri = encodeURIComponent(window.location.href);
      // 受微信授权域名限制，非线上环境统一跳转 test 环境中转页获取 code
      const pathname = '/transfer/wxOAuth';
      const querystring = `?env=${getEnv()}&redirectUri=${redirectUri}`;
      if (getEnv() !== 'prd') {
        redirectUri = encodeURIComponent(`https://mall-test.zafshealth.com${pathname}${querystring}`);
      }
      console.warn('redirectUri', redirectUri);
      const scope = 'snsapi_base';
      window.location.replace(`https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirectUri}&response_type=code&scope=${scope}#wechat_redirect`);
    }
  };

  initSeraph = () => {
    loadJS('https://s.zhongan.io/seraph-js-sdk/dist/js/monitor.2.3.1.js', initSeraphMonitorSDK);
  };

  initXFLOW() {
    // 初始化ilog埋点
    const ilog = 'https://xflowcore.zhongan.com/sdk/dist/js/v0.0.1/ilog.js?id=z7oeetwqzs6jwvec&setting=true';
    loadJS(ilog, () => {
      try {
        // @ts-ignore
        window._XFLOW_ = new XFlow({
          input: false,
          history: true,
          extendsInfo: {
            // getDynamic为动态扩展字段，如需配置动态扩展字段，需以getDynamic为属性名称，函数体里面放置动态返回的对象
            getDynamic() {
              return {
                ZAHLWYY_channelSource: cookies.get('channelSource') || '',
                ZAHLWYY_channelResourceCode: cookies.get('channelResourceCode') || '',
                ZAHLWYY_userId: cookies.get('maskusId') || '',
                ZAHLWYY_accountId: cookies.get('maskActId') || '',
              };
            },
          },
          exposure: {
            open: true,
            threshold: 0.5,
          },
          elementPushEventS: xlfowElementPushEventS,
        });
        // window._XFLOW_.setLogin(decodeURIComponent(maskusId));
      } catch (e) {
        console.log(e);
      }
    });
  }

  loadPlatformJsSDK() {
    if (validate.isFromWeixin()) {
      const wxSdkUrl = 'https://res.wx.qq.com/open/js/jweixin-1.6.0.js';
      loadJS(wxSdkUrl, noop);
    }
    if (validate.isFromZA()) {
      const zaWebviewUtilUrl = 'https://static.zhongan.com/website/assets/subject/common/thirdTips/assets/scripts/page.js';
      loadJS(zaWebviewUtilUrl, noop);
    }
    if (validate.isAlipayApplet()) {
      const alipaySdkUrl = 'https://appx/web-view.min.js';
      loadJS(alipaySdkUrl, getAliOpenInfo);
    }
  }

  render() {
    const { children } = this.props;
    return (
      <div className="app-container">{children}</div>
    );
  }
}

export default withRouter(App);
